<script>
import { uniqBy, orderBy, filter, isEmpty } from 'lodash';
import rbxComboboxMixin from './rbxComboboxMixin';

export default {
  mixins: [rbxComboboxMixin],
  props: {
    selected: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      selectedItems: [],
    };
  },
  computed: {
    mergedList() {
      const list = [...this.selectedItems, ...this.items];
      const removedEmptyItems = filter(list, item => !isEmpty(item)); // Because selected can be empty object

      return orderBy(uniqBy(removedEmptyItems, 'id'), 'id');
    },
  },
  watch: {
    selected() {
      this.selectedItems = this.selected;
    },
  },
  mounted() {
    this.selectedItems = this.selected;
  },
  methods: {
    updateSelection() {
      const selectedItemSummary = this.selectedItems
        .map(item => ({ id: item.id, translatedName: item.translatedName }));
      this.$emit('input', selectedItemSummary);
    },
  },
};
</script>

<template>
  <v-autocomplete v-model="selectedItems"
                  :items="mergedList"
                  :loading="isLoading"
                  :search-input.sync="search"
                  :allow-overflow="false"
                  :label="label"
                  @input="updateSelection"
                  height="22"
                  :error-messages="errorMessages"
                  item-value="id"
                  :item-text="itemText"
                  dense
                  multiple
                  :no-filter="searchable"
                  return-object>
    <template slot="selection"
              slot-scope="{ item, index }">
      <span class="caption" v-if="index === 0">{{ item[itemText] | truncate }}, </span>
      <span class="caption" v-if="index === 1">{{ item[itemText] | truncate }} </span>
      <span v-if="index === 2" class="grey--text caption ml-2">
        (+ {{ selectedItems.length - 2 }} weitere)
      </span>
    </template>
  </v-autocomplete>
</template>
